import React, { PureComponent } from "react";
import {branch} from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";

import * as actionsTimerManager from "../../actions/actionsTimerManager";

import moment from "moment";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

class CountdownTimerTemplates extends PureComponent {

  render() {
    let self=this;

    let componentTimerTemplates = this.props.timerTemplates.map(function (timerTemplate, i) {
      if (!timerTemplate.hasOwnProperty("deleted")) {
        let leftSpacer = <div style={{width: 16, height: 16}}/>;

        let trash =
        <div style={{ flex: 0, paddingRight: 15, cursor: "pointer"}} onClick={()=> {
          let timerTemplates = self.props.timerTemplates.slice(0);

          timerTemplates[i] = {guid: timerTemplate.guid, timestamp: moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS"), deleted: true};
          actionsTimerManager.saveTimerTemplates(timerTemplates);       
        }}>
          <FontAwesomeIcon icon="trash" size={16} color="darkgreen" />          
        </div>;

        return (
          <div style={{display: "flex", margin: 5, flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
            {leftSpacer}
            <div style={{flex: 1}}>
            <div style={{ color: "#000088", fontSize: 20, cursor: "pointer" }}
              onClick={() => {
                let objTimer = Object.assign({},timerTemplate);

                let currentChecklist = self.context.tree.get(["activity"]);
                if (objTimer.type === "custom") {
                  objTimer = JSON.parse(objTimer.custom);
                }
            
                let context = {};
                if (currentChecklist && currentChecklist.hasOwnProperty("id")) {
                  const activityId = currentChecklist.id;
                  const { selected } = currentChecklist;
                  const { listIndex, sectionIndex, itemIndex } = selected;
        
					context = {
						activityId,
						listIndex,
						sectionIndex,
						itemIndex
					};
                }
                switch (objTimer.type) {
                  case "countup": {
                    self.props.dispatch(actionsTimerManager.createCountupTimer,objTimer,context);          
                    break;
                  }
                  case "countdown":
                  default: {
                    self.props.dispatch(actionsTimerManager.createCountdownTimer,objTimer,context);          
                    break;
                  }
                }
				}}>{"Start " + timerTemplate.name}</div>
            </div>			
            {trash}  
          </div>
          );
	  } else {
		  return null;
	  }
    });

    let componentTimerTemplatesFiltered = componentTimerTemplates.filter(function (el) {
      return el !== null;
    });

	  return (
		  <div style={{ display: "flex", flexDirection: "column", maxWidth: "1024px", alignItems: "center", justifyContent: "center" }}>
			  {componentTimerTemplatesFiltered && componentTimerTemplatesFiltered.length > 0 && <div style={{ marginTop: 15, marginBottom: 15, fontWeight: "bold", fontSize: 20, color: "#ffffff" }}>Named Timers</div>}
			  {componentTimerTemplatesFiltered}
		  </div>
	  );
  }
}

CountdownTimerTemplates.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
  timerTemplates: ["timerTemplates"]
}, CountdownTimerTemplates);
